import { gql } from '@apollo/client'

export const TOP_VENUES = gql`
  query GetTopVenues($input: getTopVenuesInput) {
  getTopVenues(input: $input) {
    oVenue {
      _id
      sName
      sLocation
      sCountry
      sCity
      oSeo {
        iId
        sSlug
        sMobileSlug
      }
    }
  }
}
`

export const GET_VENUE_DETAILS = gql`
  query GetVenueDetailsById($input: getVenueDetailsByIdInput) {
  getVenueDetailsById(input: $input) {
    venue {
      _id
      sVenueKey
      sName
      sLocation
      sCountry
      bFloodLights
    }
    venueStats {
      sMatchFormat
      aStatsPerInning {
        nInningNumber
        nTotalInnings
        nAvgRuns
        nAvgWkts
        nAvgStrikeRate
      }
      iVenueId
      nCancelledMatches
      nCatches
      nFirstBatWin
      nFirstBowlWin
      nMaidens
      nStumpings
      nTossWinChooseBat
      nTossWinChooseBatMatchLoss
      nTossWinChooseBatMatchWin
      nTossWinChooseBowlMatchLoss
      nTossWinChooseBowl
      nTossWinChooseBowlMatchWin
      nTotalFours
      nTotalHunderd
      nTotalSixes
      nTotalFifty
      nTotalMatches
      nWicket5i
      nWicket4i
      nWicketsPace
      nWicketsSpin
      oHighestPartnership {
        iMatchId
        nBallFaced
        nOrder
        nRuns
      }
      oHighestScore {
        iMatchId
        nScore
        nWickets
      }
      oHighestScoreChased {
        iMatchId
        nScore
        nWickets
      }
      oLowestScore {
        iMatchId
        nScore
        nWickets
      }
      oLowestScoreDefended {
        iMatchId
        nScore
        nWickets
      }
    }
    aFormats
  }
}
`
